import { GetRunsQueryParams, RunSchema } from '@/types/schema';

import { CHILD_RUNS_SELECT } from './utils';

export function useChildRunsQueryParams({
  sessionId,
  traceId,
  run,
  rootRun,
  select,
}: {
  sessionId?: string;
  traceId?: string;
  run?: RunSchema;
  rootRun?: RunSchema;
  select?: string[];
}) {
  const query: GetRunsQueryParams = {
    is_root: false,
    select: [...CHILD_RUNS_SELECT, ...(select ?? [])],
  };

  const mSessionId = sessionId || run?.session_id || rootRun?.session_id;
  const mTraceId = traceId || run?.trace_id || rootRun?.trace_id;

  const childRunIds = rootRun?.child_run_ids ?? run?.child_run_ids;

  if (mSessionId && mTraceId) {
    query.session = [mSessionId];
    query.trace = mTraceId;
    return query;
  }

  // for public runs, session id is not available.
  if (childRunIds) {
    query.id = childRunIds;
    return query;
  }

  return null;
}
